export const SET_OPERATOR = 'SET_OPERATOR';
export const SET_VALUE = 'SET_VALUE';

export const TYPES = {
  SET_OPERATOR,
  SET_VALUE,
};

export const setOperator = operator => ({
  type: SET_OPERATOR,
  operator,
});

export const setValue = value => ({
  type: SET_VALUE,
  value,
});
